import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCarHouseVehicles } from '../../lib/carHouseVehicles';

export const fetchCarHouseVehicles = createAsyncThunk(
  'vehicles/fetchCarHouseVehicles',
  async ({ carHouseId, pagination, options = {} }) => {
    const data = await getCarHouseVehicles(carHouseId, pagination, options);

    return data;
  }
);
